export default "__VITE_ASSET__BrDkP$o$__"